import ContentLayout from '@/layouts/content-layout'
import UserVerifyView from '@/sections/user-verify/view/user-verify-view'

export default function UserVerifyPage() {
  return (
    <ContentLayout title="ยืนยันผู้ใช้งาน">
      <UserVerifyView />
    </ContentLayout>
  )
}
